import Vue from 'vue';
import Vuex from 'vuex';

import getters from './getters';
import mutations, { SET_MUNICIPALITY, SET_LOADING } from './mutations';
import createActions from './actions';
import createModules, { MODULES } from './modules';

const FILTER_MUNICIPALITY_KEY = 'filterMunicipalityId';
const AGREE_WITH_COOKIE = 'agreeWithTheCookie';
const TOGGLE_PROFILE = 'getDefaultProfile';
const AGREE_MUNICIPALITY_EXPIRES = 3650 * 24 * 60 * 60;
const FILTER_MUNICIPALITY_EXPIRES = 365 * 24 * 60 * 60;

Vue.use(Vuex);

const departmentsState = {
  departments: null,
};

const regionState = {
  regions: [],
};

const municipalitiesState = {
  municipalities: [],
  municipalityRegions: [],
};

const nokoState = {
  nokoCompetitionLevels: [],
  nokoCompetitionList: [],
  nokoCompetitionTypes: [],
  nokoProgressResult: [],
  nokoQuestionnaireForm: [],
};

const activityState = {
  activityMembers: [],
  activityLevels: [],
  activitySections: [],
  educationForms: [],
  modalCallBack: {},
};

const defaultState = {
  nextOpenModuleCard: false,
  loading: false,
  regionProfile: {},
  sections: [],
  industries: [],
  educationCategories: [],
  educationModes: [],
  organizators: [],
  organizatorsFullList: [],
  eventTypes: [],
  dictionaryDisease: [],
  financingSource: [],
  isTokensExist: null,
  apiModules: [],
  roles: [],
  payLevels: [],
  educationLevels: [],
  regionsDict: [],
  blogEventsDict: [],
  consultationsTopics: [],
  activityOrderEduLevelDict: [],
  eventOrderEduLevelsDict: [],
  workScheduleDataDict: [],
  employmentDataDict: [],
  partnerRoleDict: [],
  educationLevelDict: [],
  educationTypeDict: [],
  menuOpen: false,
  menuPanel: {
    menuOpen: false,
    search: false,
    searchText: '',
  },
};

const modulesState = {
  modulesSections: [],
};

const professionState = {
  workTypes: [],
  workSpheres: [],
  workPlaces: [],
  profStandarts: [],
};
const defaultView = {
  defaultLayout: {
    config: {},
    dataSet: [],
  },
};

const allState = {
  ...defaultView,
  ...defaultState,
  ...municipalitiesState,
  ...activityState,
  ...modulesState,
  ...nokoState,
  ...regionState,
  ...departmentsState,
  ...professionState,
};

const createMainStore = (params) => {

  const { $cookie } = params;
  const store = new Vuex.Store({
    state: {
      ...allState,
      municipality: $cookie.load(FILTER_MUNICIPALITY_KEY) || null,
      agreeWithTheCookie: $cookie.load(AGREE_WITH_COOKIE) || false,
    },
    getters,
    mutations: mutations,
    actions: createActions(params),
    modules: createModules(params),
  });

  // Следим за изменением параметра municipality в query string
  // Роут подключается через vuex-router-sync в app.js
  store.watch(
    (state) => state.route && state.route.query.municipality,
    (municipality) => {
      if (municipality !== undefined) {
        store.commit(SET_MUNICIPALITY, municipality);
      }
    }
  );

  // Следим за изменением свойства municipality и обновляем куки
  store.watch(
    (state) => state.municipality,
    (municipality) => {
      if (!municipality || municipality === 'undefined') {
        return $cookie.remove(FILTER_MUNICIPALITY_KEY);
      }

      $cookie.save(FILTER_MUNICIPALITY_KEY, municipality, {
        expires: FILTER_MUNICIPALITY_EXPIRES,
        path: '/',
      });
    }
  );

  store.watch((state) => {
    if (state.loading) store.commit(SET_LOADING, false);
  });

  store.watch(
    (state) => state.agreeWithTheCookie,
    (agreeWithTheCookie) => {
      if (!agreeWithTheCookie || agreeWithTheCookie === 'undefined') {
        return $cookie.remove(AGREE_WITH_COOKIE);
      }

      $cookie.save(AGREE_WITH_COOKIE, agreeWithTheCookie, {
        expires: AGREE_MUNICIPALITY_EXPIRES,
        path: '/',
      });
    }
  );

  return store;
};

export { createMainStore, MODULES };

export default createMainStore;



// WEBPACK FOOTER //
// ./src/store/index.js